/* eslint-disable guard-for-in */
import { Pipe, PipeTransform } from '@angular/core';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import * as dayjs from 'dayjs';
import * as timezone from 'dayjs/plugin/timezone';
import * as utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

@Pipe({
    name: 'dateformat',
    pure: true,
    standalone: true
})
export class DateFormatPipe implements PipeTransform {
    dateFormat: any = 'DD/MM/YYYY';
    timezone: any = dayjs?.tz?.guess();
    constructor(
        private utilityService: UtilityService
    ) {
            this.dateFormat = this.utilityService.dateFormat;
            this.timezone = this.utilityService.timeZone;
        }

    transform(value: any, dayFormat?: string, isUTC?: boolean, formatWithDate: boolean = true, timeZone: string = this.timezone): any {
        timeZone = this.utilityService.isEmptyOrUndefined(timeZone) ? this.utilityService.timeZone : timeZone;
        let dateFormat: any = this.dateFormat;
        if (dayFormat && formatWithDate) {
            dateFormat = dateFormat + dayFormat;
        }
        else if(dayFormat && !formatWithDate){
            dateFormat = dayFormat;
        }
        if(isUTC && value){
            value = dayjs.utc(value).format(dateFormat);
        }
        if (value) {
            value = dayjs(value).tz(timeZone).format(dateFormat);
        }
        return value;
    }

    isSameDate(fromDate: any, toDate: any): boolean {
        return dayjs(this.transform(fromDate)).isSame(this.transform(toDate));
    }
}
